import { Modal } from '@fasstech/middle-design-system';

const ExtraUnauthorizedModal = ({
  isDisplayed,
  unauthorizedModalMessage,
  setUnauthorizedModalMessage
}) => {
  const hideModal = () => {
    setUnauthorizedModalMessage('');
  };

  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={'OK'}
      onClose={hideModal}
      onClick1={hideModal}
      icon="circleReject">
      <div className="mx-auto text-primary font-medium text-xl text-center">
        <div className="text-2xl font-semibold mb-4">Attention</div>
        <p>{unauthorizedModalMessage}</p>
      </div>
    </Modal>
  );
};

export default ExtraUnauthorizedModal;
